<template>
  <div class="student-card rounded border">
    <icon-view
      :has-border="false"
      icon="fas fa-user-alt color-orange"
      icon-size="1rem"
      :title="title"
      variant="custom-icon-view"
    />
    <template
      v-if="!showReadOnly"
    >
      <validation-observer ref="studentForm">
        <div class="row mx-0" :class="!student ? 'mt-5' : 'mt-4'">
          <div class="col-12">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="model.sie"
                placeholder="Escribir Número de SIE"
                :error="errors[0]"
                type="number"
                custom-error-msg="El número de SIE es requerido."
              />
              <div
                v-if="
                  student !== null &&
                    student.fullName === null &&
                    student.replacementStudentSieId === null
                "
                class="col-12 justify-content-end no-border color-primary-4"
              >
                <div class="w-100 text-left">
                  <div class="d-inline">
                    <em class="fa fa-times-circle" />
                  </div>
                  <p class="text-left d-inline">
                    No se encontró número de SIE en el sistema.
                  </p>
                </div>
              </div>
              <div
                v-if="
                  student !== null && student.replacementStudentSieId !== null
                "
                class="col-12 justify-content-end no-border color-primary-4"
              >
                <div class="w-100 text-left">
                  <div class="d-inline">
                    <em class="fa fa-times-circle" />
                  </div>
                  <p class="text-left d-inline">
                    El SIE ingresado fue reemplazado por el SIE "{{
                      student.replacementStudentSieId
                    }}".
                    <action-button
                      variant="no-border"
                      class="invert-button"
                      text="Invertir Reemplazo"
                      @click="onStudentInvert"
                    />
                  </p>
                </div>
              </div>
              <div
                v-if="
                  student !== null && student.errorMessage !== ''
                "
                class="col-12 justify-content-end no-border color-primary-4"
              >
                <div class="w-100 text-left">
                  <div class="d-inline">
                    <em class="fa fa-times-circle" />
                  </div>
                  <p class="text-left d-inline">
                    {{student.errorMessage}}
                  </p>
                </div>
              </div>
            </validation-provider>
          </div>
        </div>
        <div class="row mx-0 mt-2">
          <div class="col-12 mt-12 d-flex justify-content-end">
            <action-button
              variant="success"
              i="fas fa-search"
              text="Buscar"
              @click="onStudentSearch"
            />
          </div>
        </div>
      </validation-observer>
    </template>
    <template v-else>
      <div
        class="col-12 mb-2 d-flex justify-content-between align-items-center"
      >
        <span class="color-green font-weight-bold">
          {{ student.sie }}
        </span>
        <action-button
          v-if="canRemove"
          variant="outline-danger"
          i="fas fa-times-circle"
          @click="onRemoveStudent"
        />
      </div>
      <div class="col-12">
        <span class="data-title">Nombre:</span>
        {{ student.fullName }}
      </div>
      <div class="col-12">
        <span class="data-title">Fecha de Nacimiento:</span>
        {{ student.birthdate | date }}
      </div>
      <div class="col-12">
        <span class="data-title">N&uacute;mero de Seguro Social:</span>
        <span v-if="showSsn">
          {{ formatSSN(student.ssn) }}
        </span>
        <span v-else>
          {{ student.ssn | ssn }}
        </span>
        <em
          class="fas cursor-pointer ml-2"
          :class="!showSsn ? 'fa-eye-slash' : 'fa-eye'"
          @click="showSsnHandler"
        />
      </div>
      <div class="col-12">
        <span class="data-title">Estatus:</span>
        {{ student.status | empty }}
      </div>
    </template>
  </div>
</template>

<script>
import IconView from 'icon-view';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import { ssn } from '@/utils/filters.js';

export default {
  name: 'StudentCard',
  filters: { ssn },
  components: { IconView, CustomInput, ActionButton },
  props: {
    title: {
      type: String,
      default: () => 'SIE del Estudiante',
    },
    student: {
      type: Object,
      default: () => null,
    },
    empty: {
      type: Boolean,
      default: () => false,
    },
    canRemove: {
      type: Boolean,
      default: () => true,
    },
  },
  data: () => ({
    model: {
      sie: null,
    },
    showSsn: false,
    searching: false,
  }),
  computed:{
    showReadOnly() {
      return this.student !== null && this.student.fullName !== null
               && (this.student.errorMessage === null ||
                  this.student.errorMessage === undefined
                  || this.student.errorMessage === '');
    },
  },
  methods: {
    formatSSN(ssn) {
      return ssn.slice(0, 3) + '-' + ssn.slice(3, 5) + '-' + ssn.slice(5)
    },
    async onStudentSearch() {
      const isValid = await this.$refs.studentForm.validate();
      if (!isValid) return;
      this.$emit('search-student', this.model.sie);
      this.searching = true;
    },
    onRemoveStudent() {
      this.$emit('remove-student');
      this.cleanForm();
    },
    cleanForm() {
      this.model.sie = null;
      this.searching = false;
    },
    showSsnHandler() {
      this.showSsn = !this.showSsn;
    },
    onStudentInvert() {
      this.$emit('invert-student', this.model.sie);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';

.student-card ::v-deep {
  min-height: 16.4375rem;
  border: 1px solid #dedede;
  border-radius: 0.25rem;
  padding: 1.5rem;
  .custom-icon-view {
    margin-bottom: 0.5rem;
    .font-16.color-gray-7 {
      font-size: 1rem !important;
      color: map-get($colors, 'gray-7') !important;
    }
  }
}
.invert-button {
  color: #c54753;
  text-decoration: underline;
}
</style>
